import React from 'react';

import MainModal from 'shared/ui/Modal/MainModal';
import Button from 'shared/ui/Button/Button/Button';
import Correct from 'shared/ui/icons/General/Correct';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import {ITariff} from 'entities/tariff';

import {PALETTE} from 'shared/config/model/palette';

import styles from './LegalSuccessModal.module.scss';

interface LegalSuccessModalProps {
    open: boolean;
    onClose: () => void;
    item: ITariff & {
        period: number;
        price: number;
    };
}

const LegalSuccessModal: React.FC<LegalSuccessModalProps> = ({item, open, onClose }) => {
    const STEPS = [
        'Бухгалтерия направит приглашение для обмена документами в ЭДО.',
        'После принятия приглашения бухгалтерия сформирует счёт и отправит его на указанный вами email и в ЭДО.',
        'После оплаты счёта мы зафиксируем оплату, активируем оплаченный тариф и направим вам уведомление.',
        'Бухгалтерия направит акт в ЭДО и на электронную почту.',
    ];

    const SUCCESS_MESSAGE = 'Спасибо! Мы получили вашу заявку.';
    
    return (
        <MainModal
            open={open}
            handleClose={onClose}
            size="md"
            header={`Оплата тарифа - ${item.name}${item.is_archive ? ' (архивный)' : ''}`}
        >
            <ModalBodyWrapper>
                <div className={styles.content}>
                    <div className={styles.icon} aria-hidden="true"><Correct color={PALETTE.success}/></div>
                    <span className={styles.title}>{SUCCESS_MESSAGE}</span>
                    <div className={styles.message}>
                        <span className={styles.title}>Дальнейшие шаги:</span>
                        <ol className={styles.text}>
                            {STEPS.map((text, index) => (
                                <li key={index}>{text}</li>
                            ))}
                        </ol>
                    </div>
                </div>
            </ModalBodyWrapper>
            <Button
                onClick={onClose}
                size="lg"
                block
                type="button"
            >
                Понятно
            </Button>
        </MainModal>
    );
};

export default LegalSuccessModal;